<template>
  <v-row>
    <v-col cols="3">
      <span class="label-text">Rack</span>
      <div class="input-mb input-box d-flex flex-nowrap">
        <v-select
          :items="warehouseRackList"
          v-model="warehouseMapLocation.rack.id"
          placeholder="Rack"
          item-text="label"
          item-value="id"
          class="r-field general-settings-select"
          @input="changeRack"
        />
      </div>
    </v-col>
    <v-col cols="3">
      <span class="label-text">Shelf</span>
      <div class="input-mb input-box d-flex flex-nowrap">
        <v-select
          :items="warehouseRackShelfList"
          v-model="warehouseMapLocation.shelf.id"
          placeholder="Shelf"
          item-text="label"
          item-value="id"
          class="r-field general-settings-select"
          @input="changeShelf"
        />
      </div>
    </v-col>
    <v-col cols="3">
      <span class="label-text">Bin</span>
      <div class="input-mb input-box d-flex flex-nowrap">
        <v-select
          :items="warehouseRackShelfBinList"
          v-model="warehouseMapLocation.bin.id"
          placeholder="Bin"
          item-text="label"
          item-value="id"
          class="r-field general-settings-select"
          @change="changeBin"
        />
      </div>
    </v-col>
    <v-col cols="3">
      <span class="label-text">Qty</span>
      <div class="input-mb input-box d-flex flex-nowrap">
        <v-text-field
          dense
          type="number"
          min="0"
          step="1"
          placeholder="0"
          maxlength="8"
          :rules="numberRules"
          v-model="warehouseMapLocation.value"
        />
        <div class="delete-rounded-button" @click='showDeletePopup'>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color='#c3c3c3' v-bind="attrs" v-on="on">mdi-close-circle</v-icon>
            </template>
            <span>Remove location</span>
          </v-tooltip>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'WarehouseMapLocation',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    warehouseMapLocation: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    warehouseRackList: [],
    warehouseRackShelfList: [],
    warehouseRackShelfBinList: [],
    numberRules: [(value) => (!isNaN(+value) && value >= 0) || 'Invalid number format']
  }),
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse'])
  },
  methods: {
    prepareRackList() {
      return this.getActiveWarehouse.map.racks.map(rack => {
        return {
          id: rack.id,
          label: rack.label
        }
      })
    },
    prepareRackShelfList() {
      const rackId = this.warehouseMapLocation.rack?.id
      if (!rackId) {
        return []
      }
      return this.getActiveWarehouse.map
        .racks.find(rack => rack.id === rackId)
        .shelves.map(shelf => {
          return {
            id: shelf.id,
            label: shelf.label
          }
        })
    },
    prepareRackShelfBinList() {
      const rackId = this.warehouseMapLocation.rack?.id
      const shelfId = this.warehouseMapLocation.shelf?.id
      if (!rackId || !shelfId) {
        return []
      }
      return this.getActiveWarehouse.map
        .racks.find(rack => rack.id === rackId)
        .shelves.find(shelf => shelf.id === shelfId)
        .bins.map(bin => {
          return {
            id: bin.id,
            label: bin.label
          }
        })
    },
    changeRack() {
      const rackId = this.warehouseMapLocation.rack?.id
      if (!rackId) {
        return
      }
      const rack = this.getActiveWarehouse.map.racks.find(rack => (rack.id === rackId))
      this.warehouseMapLocation.rack.label = rack.label

      this.warehouseRackShelfList = this.prepareRackShelfList()
      this.warehouseMapLocation.shelf = { id: null, label: '' }

      this.warehouseRackShelfBinList = []
      this.warehouseMapLocation.bin = { id: null, label: '' }
    },
    changeShelf() {
      const rackId = this.warehouseMapLocation.rack?.id
      const shelfId = this.warehouseMapLocation.shelf?.id
      if (!rackId || !shelfId) {
        return
      }
      const rack = this.getActiveWarehouse.map.racks.find(rack => (rack.id === rackId))

      const shelf = rack.shelves.find(shelf => (shelf.id === shelfId))
      this.warehouseMapLocation.shelf.label = shelf.label

      const busyBinIds = this.item.warehouseLocations.map(location => location.bin.id)
      this.warehouseRackShelfBinList = shelf.bins.filter(bin => {
        return !(busyBinIds.find(id => id === bin.id))
      })
      this.warehouseMapLocation.bin = { id: null, label: '' }
    },
    changeBin() {
      const rackId = this.warehouseMapLocation.rack?.id
      const shelfId = this.warehouseMapLocation.shelf?.id
      const binId = this.warehouseMapLocation.bin?.id
      if (!rackId || !shelfId) {
        return
      }

      const rack = this.getActiveWarehouse.map.racks.find(rack => (rack.id === rackId))
      const shelf = rack.shelves.find(shelf => (shelf.id === shelfId))
      const bin = shelf.bins.find(bin => (bin.id === binId))
      this.warehouseMapLocation.bin.label = bin.label
    },
    showDeletePopup() {
      this.$emit('showPopupDelete', this.warehouseMapLocation)
    }
  },
  created() {
    this.warehouseRackList = this.prepareRackList()
    this.warehouseRackShelfList = this.prepareRackShelfList()
    this.warehouseRackShelfBinList = this.prepareRackShelfBinList()
  }
}
</script>

<style scoped lang="scss">
.delete-rounded-button {
  margin: 12px 0 0 0;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background-color: transparent;

    i {
      color: darken(#c3c3c3, 20%) !important;
    }
  }
}
</style>
